import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_PHASES, canTransitionQuizBuzzer, scoreQuizAnswer, transitionQuizBuzzer } from "./quiz-buzzer-machine.js";
export const TRUE_OR_FALSE_DEFAULT_CONFIG = Object.freeze({
    rounds: 10,
    answerDurationMs: 8_000,
    roundResultDurationMs: 4_000,
    correctBasePoints: 1_000,
    speedBonusMaxPoints: 500
});
const actions = ["START", "ANSWER", "ROUND_COMPLETE", "NEXT_ROUND", "FINISH", "PAUSE", "RESUME", "SKIP_ROUND", "END", "PLAY_AGAIN"];
export const TRUE_OR_FALSE_DEFINITION = defineGame({
    key: "TRUE_OR_FALSE",
    metadata: {
        slug: "vero-o-falso-blitz",
        name: "Vero o Falso Blitz",
        description: "Decidi in pochi secondi se l’affermazione è vera o falsa e conquista il bonus velocità.",
        icon: "⚡",
        catalogStatus: "available",
        maturity: "beta",
        hostAccess: true,
        minimumPlayers: 1,
        maximumPlayers: 100,
        capabilities: ["realtime", "qr-join", "public-display", "persistent-ranking", "questions"]
    },
    initialConfig: TRUE_OR_FALSE_DEFAULT_CONFIG,
    supportedConfiguration: ["rounds", "answerDurationMs", "roundResultDurationMs", "correctBasePoints", "speedBonusMaxPoints"],
    configurationProfiles: {
        quick: { configuration: { rounds: 5, answerDurationMs: 7_000, roundResultDurationMs: 3_000 }, estimatedMinutes: 3 },
        standard: { configuration: {}, estimatedMinutes: 6 },
        extended: { configuration: { rounds: 20, answerDurationMs: 10_000 }, estimatedMinutes: 12 }
    },
    createInitialState: (config = {}) => ({
        phase: "LOBBY",
        roundNumber: 0,
        totalRounds: config.rounds ?? TRUE_OR_FALSE_DEFAULT_CONFIG.rounds,
        pausedFromPhase: null
    }),
    states: QUIZ_BUZZER_PHASES,
    actions,
    canTransition: (state, action) => canTransitionQuizBuzzer(state.phase, action),
    transition: (state, action) => ({
        ...state,
        phase: transitionQuizBuzzer(state.phase, action, state.pausedFromPhase === "QUESTION" || state.pausedFromPhase === "ROUND_RESULT"
            ? { resumePhase: state.pausedFromPhase }
            : {})
    }),
    scoreDelta: (decision) => scoreQuizAnswer(decision === "CORRECT", TRUE_OR_FALSE_DEFAULT_CONFIG.answerDurationMs, TRUE_OR_FALSE_DEFAULT_CONFIG.answerDurationMs, TRUE_OR_FALSE_DEFAULT_CONFIG),
    views: {
        host: "true-or-false/host",
        player: "true-or-false/player",
        display: "true-or-false/display"
    },
    realtime: {
        clientToServer: ["host:start", "host:pause", "host:resume", "host:skip-round", "host:end", "host:play-again", "player:answer"],
        serverToClient: ["action-result", "action-error", "answer-result"]
    }
});
//# sourceMappingURL=true-or-false-definition.js.map